import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';
import { getEl, getEls } from '../helpers';
import AnimationDebugger from '../components/animation-debugger';

export default class Careers extends Scene {

	sectionSelector = '#careers';

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);

        const spotlight1 = this.elContainer.querySelector(".career-spotlight-1");

        //SPOTLIGHT 1 ANIMATION
        const spotimg = spotlight1.querySelector('.spot-image-other-side img');

        let dx = 0;
        let dy = 0;

        manager.app.spotlighter.addSpotlightAnimation(
            {
                targets: spotlight1.querySelector('.zoomer'),
                scale: [1,1.1],
                duration: 2000,
                easing: "easeOutQuart",
            },
            spotlight1,
            200,
            (anim, delta) => {

                const xRatio = ((anim.mouseX / anim.elWidth)-0.5)*-1;
                const yRatio = ((anim.mouseY / anim.elHeight)-0.5)*-1;
                dx += (xRatio - dx)*delta*anim.smoothSpeed;
                dy += (yRatio - dy)*delta*anim.smoothSpeed;
                // @ts-ignore
                spotimg.style.transform = 'translate('+dx+'vw, '+dy+'vw)';
            },
            () => {
                spotlight1.querySelector(".anim-heading").dispatchEvent(new CustomEvent('play'));
            },
            true
        );


        //spotlight interaction:
        // spotlight1.addEventListener('click', (e) => {
        //     e.preventDefault();
        //     manager.app.modaller.openModal('social');
        // });

	}

}
